import { render, staticRenderFns } from "./AssertionsEditor.vue?vue&type=template&id=56c3d763&scoped=true&"
import script from "./AssertionsEditor.vue?vue&type=script&lang=ts&"
export * from "./AssertionsEditor.vue?vue&type=script&lang=ts&"
import style0 from "./AssertionsEditor.vue?vue&type=style&index=0&id=56c3d763&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56c3d763",
  null
  
)

export default component.exports